/* Swubie cart-drawer upsell: adds the Doekjestasje and refreshes the drawer. */
(function () {
  function updateDrawer(data) {
    if (data.sections && data.sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var innerNew = parsed.querySelector('.drawer__inner');
      var innerCur = document.querySelector('#CartDrawer .drawer__inner');
      if (innerNew && innerCur) innerCur.innerHTML = innerNew.innerHTML;
      var footNew = parsed.querySelector('.drawer__footer');
      var footCur = document.querySelector('#CartDrawer .drawer__footer');
      if (footNew && footCur) footCur.innerHTML = footNew.innerHTML;
    }
    if (data.sections && data.sections['cart-icon-bubble']) {
      var pIcon = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var bubble = document.getElementById('cart-icon-bubble');
      var src = pIcon.querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.swubie-upsell__add');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Toevoegen...';

    var body = new FormData();
    body.append('id', vid);
    body.append('quantity', '1');
    body.append('sections', 'cart-drawer,cart-icon-bubble');

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (data) { updateDrawer(data); })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
        alert((window.SwubieI18n || {}).upsellError || 'Kon het tasje niet toevoegen. Probeer het opnieuw.');
      });
  });
})();
